const state = {
  list: [],
  selectedLocationAddress: null,
};

const getters = {
  locationAddresses: (state) => state.list,
  selectedLocationAddress: (state) => state.selectedLocationAddress,
};

const actions = {
  async fetchLocationAddresses({ commit }, { id, locationId }) {
    const response = await this._vm.$http.get(
      `/restapi/users/${id}/locations/staticip/${locationId}/addresses`
    );
    commit("setLocationAddresses", response.data);
  },

  async fetchLocationAddress({ commit }, { id, locationId, addressId }) {
    const response = await this._vm.$http.get(
      `/restapi/users/${id}/locations/staticip/${locationId}/addresses/${addressId}`
    );

    const index = state.list.findIndex(
      (locationAddress) => locationAddress.id === response.data.id
    );

    if (index === -1) {
      commit("addLocationAddress", response.data);
    } else {
      commit("updateLocationAddress", {
        idx: index,
        locationAddress: response.data,
      });
    }
    commit("setSelectedLocationAddress", response.data);
  },

  async createLocationAddress({ commit }, { id, locationId, body }) {
    const response = await this._vm.$http.post(
      `/restapi/users/${id}/locations/staticip/${locationId}/addresses`,
      body
    );
    commit("addLocationAddress", response.data);
  },

  async updateLocationAddress({ commit }, { id, locationId, addressId, body }) {
    const response = await this._vm.$http.post(
      `/restapi/users/${id}/locations/staticip/${locationId}/${addressId}`,
      body
    );
    commit("updateLocationAddress", response.data);
  },

  async deleteLocationAddress({ commit }, { id, locationId, addressId }) {
    const response = await this._vm.$http.delete(
      `/restapi/users/${id}/locations/staticip/${locationId}/${addressId}`
    );
    commit("deleteLocationAddress", response.data);
  },
};

const mutations = {
  setLocationAddresses: (state, data) => (state.list = data),
  setSelectedLocationAddress: (state, data) =>
    (state.selectedLocationAddress = data),
  addLocationAddress: (state, data) => state.list.push(data),
  updateLocationAddress: (state, data) =>
    (state.list[`${data.idx}`] = data.locationAddress),
  deleteLocationAddress: (state, data) =>
    (state.list = state.list.filter(
      (locationAddress) => locationAddress.id !== data.id
    )),
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
